// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3SOYb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Linje/Linje.scss
 ** module id = 444
 ** module chunks = 0
 **/